/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListAvailableNumber = {
    type: 'array',
    contains: {
        type: 'PurchaseNumber',
    },
};